import React, { Component } from 'react'

import style from './style.css'

class Valign extends Component {
  render() {
    return (
        <div className={style.valign}>
            <div
                className={style[`valign${this.props.position || 'Middle'}`]}
                style={{
                    textAlign: this.props.text || 'left',
                    height: this.props.height || 'auto'
                }}
                >
                {this.props.children}
            </div>
        </div>  
    )
  }
}

export default Valign


// WEBPACK FOOTER //
// ./src/SPRINTA/Topbar/atoms/Valign/index.js